import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;

import { MenuService } from '../../core/menu/menu.service';
import { SettingsService } from '../../core/settings/settings.service';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/user-service';
import { LoginViewModel } from 'src/app/routes/pages/login/login-view-model';
import * as CryptoJS from 'crypto-js';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {

    menuItems: Array<any>;
    router: Router;
    sbclickEvent = 'click.sidebar-toggle';
    $doc: any = null;

    userService: UserService = this.injector.get(UserService);
    user: User;
    loginViewModel: LoginViewModel = this.injector.get(LoginViewModel);
  
    constructor(public menu: MenuService, public settings: SettingsService, public injector: Injector) {
        this.user =  this.loginViewModel.loginUser;
        if( this.user == undefined){
            try {
                let ciphertext = localStorage.getItem('loginUser');
                var bytes  = CryptoJS.AES.decrypt(ciphertext, 'somnicSecretKey');
                var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                this.user = new User(decryptedData);
            } catch (error) {
                console.error('Error getting data from localStorage', error);
                this.router.navigate(['login']);
            }
        }
        

        var permissionDic = {}
        this.user.permissionList.forEach(permission => {
            if(permission.name == 'home'){
                permissionDic['Home'] = 1;
            }
            if(permission.name == 'user'){
                permissionDic['User'] = 1;
            }
            if(permission.name == 'patient'){
                permissionDic['Patient'] = 1;
            }

            //permissionDic['Device'] = 1;
            //permissionDic['ImportPatient'] = 1;

            if(permission.name == 'organization'){
                permissionDic['Organization'] = 1;
            }
            if(permission.name == 'location'){
                permissionDic['Location'] = 1;
            }
            if(permission.name == 'profile'){
                permissionDic['Profile'] = 1;
            }
            if(permission.name == 'organizationlist'){
                permissionDic['OrganizationList'] = 1;
            }
        });

        //console.log(this.user.add_cloud_device_history);
        if(this.user.add_cloud_device_history == 1){
            permissionDic['CloudDeviceHistory'] = 1;
        }

        //20240314 新增disable pressure的序號介面
        if(this.user.disable_pressure_serial_ui == 1){
            permissionDic['DisablePressureSerialList'] = 1;
        }

        //console.log(this.user.serial_add);
        if(this.user.serial_add == 1){
            permissionDic['Device'] = 1;
        }

        if(this.user.ota == 1){
            permissionDic['OtaList'] = 1;
        }

        if(this.user.apk == 1){
            permissionDic['ApkList'] = 1;
        }

        console.log(this.user.import_patient);
        if(this.user.import_patient == 1){
            permissionDic['ImportPatient'] = 1;
        }
        console.log(this.user.alluserpatientlist);
        if(this.user.alluserpatientlist == 1){
            permissionDic['AllUserPatient'] = 1;
        }

        console.log(this.user.vauserpatientlist);
        if(this.user.vauserpatientlist == 1){
            permissionDic['VaUserPatient'] = 1;
        }

        console.log(this.user.gateway);
        if(this.user.gateway == 1){
            permissionDic['Gatewaynode'] = 1;
        }

        console.log(this.user.gateway_register);
        if(this.user.gateway_register == 1){
            permissionDic['Gatewayregister'] = 1;
        }

        this.menuItems = [];
        menu.getMenu().forEach(item => {
            var key = item.text;
            if(permissionDic[key] == 1){
                this.menuItems.push(item);
            }
        });
        //this.menuItems = menu.getMenu();
    }

    ngOnInit() {

        this.router = this.injector.get(Router);

        this.router.events.subscribe((val) => {
            // close any submenu opened when route changes
            this.removeFloatingNav();
            // scroll view to top
            window.scrollTo(0, 0);
            // close sidebar on route change
            this.settings.setLayoutSetting('asideToggled', false);
        });

        // enable sidebar autoclose from extenal clicks
        this.anyClickClose();

    }

    anyClickClose() {
        this.$doc = $(document).on(this.sbclickEvent, (e) => {
            if (!$(e.target).parents('.aside-container').length) {
                this.settings.setLayoutSetting('asideToggled', false);
            }
        });
    }

    ngOnDestroy() {
        if (this.$doc)
            this.$doc.off(this.sbclickEvent);
    }

    toggleSubmenuClick(event) {

        event.preventDefault();

        if (!this.isSidebarCollapsed() && !this.isSidebarCollapsedText() && !this.isEnabledHover()) {

            let ul = $(event.currentTarget.nextElementSibling);

            // hide other submenus
            let parentNav = ul.parents('.sidebar-subnav');
            $('.sidebar-subnav').each((idx, el) => {
                let $el = $(el);
                // if element is not a parent or self ul
                if (el !== parentNav[0] && el !== ul[0]) {
                    this.closeMenu($el);
                }
            });

            // abort if not UL to process
            if (!ul.length) {
                return;
            }

            // any child menu should start closed
            ul.find('.sidebar-subnav').each((idx, el) => {
                this.closeMenu($(el));
            });

            // toggle UL height
            const ulHeight = ul.css('height')
            if (ulHeight === 'auto' || parseInt(ulHeight, 10)) {
                this.closeMenu(ul);
            }
            else {
                // expand menu
                ul.on('transitionend', () => {
                    ul.css('height', 'auto').off('transitionend');
                }).css('height', ul[0].scrollHeight);
                // add class to manage animation
                ul.addClass('opening');
            }

        }

    }

    // Close menu collapsing height
    closeMenu(elem) {
        elem.css('height', elem[0].scrollHeight); // set height
        elem.css('height', 0); // and move to zero to collapse
        elem.removeClass('opening');
    }

    toggleSubmenuHover(event) {
        let self = this;
        if (this.isSidebarCollapsed() || this.isSidebarCollapsedText() || this.isEnabledHover()) {
            event.preventDefault();

            this.removeFloatingNav();

            let ul = $(event.currentTarget.nextElementSibling);
            let anchor = $(event.currentTarget);

            if (!ul.length) {
                return; // if not submenu return
            }

            let $aside = $('.aside-container');
            let $asideInner = $aside.children('.aside-inner'); // for top offset calculation
            let $sidebar = $asideInner.children('.sidebar');
            let mar = parseInt($asideInner.css('padding-top'), 0) + parseInt($aside.css('padding-top'), 0);
            let itemTop = ((anchor.parent().position().top) + mar) - $sidebar.scrollTop();

            let floatingNav = ul.clone().appendTo($aside);
            let vwHeight = document.body.clientHeight;

            // let itemTop = anchor.position().top || anchor.offset().top;

            floatingNav
                .addClass('nav-floating')

            // each item has ~40px height
            // multiply to force space for at least N items
            var safeOffsetValue = (40 * 5)
            var navHeight = floatingNav.outerHeight(true) + 2; // 2px border
            var safeOffset = navHeight < safeOffsetValue ? navHeight : safeOffsetValue;

            var displacement = 25; // displacement in px from bottom

            // if not enough space to show N items, use then calculated 'safeOffset'
            var menuTop = (vwHeight - itemTop > safeOffset) ? itemTop : (vwHeight - safeOffset - displacement);

            floatingNav
                .removeClass('opening') // necesary for demo if switched between normal//collapsed mode
                .css({
                    position: this.settings.getLayoutSetting('isFixed') ? 'fixed' : 'absolute',
                    top: menuTop,
                    bottom: (floatingNav.outerHeight(true) + menuTop > vwHeight) ? (displacement+'px') : 'auto'
                });

            floatingNav
                .on('mouseleave', () => { floatingNav.remove(); })
                .find('a').on('click', function(e) {
                    e.preventDefault(); // prevents page reload on click
                    // get the exact route path to navigate
                    let routeTo = $(this).attr('route');
                    if (routeTo) self.router.navigate([routeTo]);
                });

            this.listenForExternalClicks();

        }

    }

    listenForExternalClicks() {
        let $doc = $(document).on('click.sidebar', (e) => {
            if (!$(e.target).parents('.aside-container').length) {
                this.removeFloatingNav();
                $doc.off('click.sidebar');
            }
        });
    }

    removeFloatingNav() {
        $('.nav-floating').remove();
    }

    isSidebarCollapsed() {
        return this.settings.getLayoutSetting('isCollapsed');
    }
    isSidebarCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }
    isEnabledHover() {
        return this.settings.getLayoutSetting('asideHover');
    }
}
